"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatString = exports.toUpperSnake = exports.getBackendVersion = exports.getVarEnv = exports.getDateBeforeMonths = exports.isSecondaryWorkflowTable = exports.isMainWorkflowTable = exports.decrypt = exports.encrypt = exports.getErrorStatus = exports.getErrorBody = exports.getSuccessBody = exports.flatten = exports.flatMapAsync = exports.flatMap = exports.validateJOI = exports.interService = exports.groupObjectsByProperty = exports.arrayIntersection = exports.IDSource = exports.sanatizeString = void 0;
const errors_1 = require("./errors");
const Cryptr = require("cryptr");
const cryptr = new Cryptr("OptimetriksExtraSecretKey");
let currentMsIndex = 0;
let lastTimestamp = 0;
const chars = "abcdefghijklmnopqrstuvwxyz";
const sanatizeString = (str) => {
    return str
        ? str
            .split("''")
            .map((s) => s.split("'").join("''"))
            .join("''")
        : "";
};
exports.sanatizeString = sanatizeString;
/**
 * generate IDs
 * @return {string}
 */
function IDSource() {
    let currentTimestamp = Date.now();
    if (currentTimestamp !== lastTimestamp) {
        currentMsIndex = 1e6 + Math.floor(Math.random() * 100000);
        lastTimestamp = currentTimestamp;
    }
    currentMsIndex += 111;
    let id1 = currentTimestamp.toString(36) + currentMsIndex.toString(36);
    let id2 = id1.split("").reverse().join("");
    let prefix = "";
    for (let i = 0; i < 4; i++) {
        prefix += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return prefix + id2;
}
exports.IDSource = IDSource;
/**
 * returns items in array a, that are also in array b.
 * @param a the first array
 * @param b the second array
 */
function arrayIntersection(a, b) {
    return a.filter((item) => {
        return b.indexOf(item) !== -1;
    });
}
exports.arrayIntersection = arrayIntersection;
/**
 * returns items grouped by property
 * @param items the first array
 * @param property the second array
 */
function groupObjectsByProperty(items, property) {
    let grouped = {};
    items.forEach((objectItem) => {
        let item = grouped[objectItem[property]];
        if (item)
            item.push(objectItem);
        else
            grouped[objectItem[property]] = [objectItem];
    });
    return grouped;
}
exports.groupObjectsByProperty = groupObjectsByProperty;
/**
 * return the host and port number of a service
 */
function interService(serviceName) {
    const env = process.env.NODE_ENV || "development";
    const envs = process.env;
    if (env === "development" || env === "test" || env === "dev") {
        if (serviceName === "service-comms")
            return {
                host: "localhost",
                port: "8903",
            };
        else if (serviceName === "service-cleanup")
            return {
                host: "localhost",
                port: "8908",
            };
    }
    serviceName = serviceName.replace(/-/g, "_").toUpperCase();
    const hostString = `${serviceName}_SERVICE_HOST`;
    const portString = `${serviceName}_SERVICE_PORT`;
    let host = envs[hostString];
    let port = envs[portString];
    if (serviceName === "SERVICE_CLEANUP") {
        if (envs.HEAD_VERSION && envs.HEAD_VERSION !== "") {
            host = envs.HEAD_VERSION;
        }
    }
    return {
        host,
        port,
    };
}
exports.interService = interService;
/**
 * given a joi schema and an object validate
 * the object against the schema
 * @param joiSchema the joischema
 * @param obj the object we are validating against the schema
 * @returns {Promise<undefined|error>}
 */
const validateJOI = (joiSchema, obj) => {
    return new Promise(async (resolve, reject) => {
        try {
            const value = await joiSchema.validateAsync(obj);
            resolve(value);
        }
        catch (err) {
            let msgString = err.message.replace(/[\[\]"]+/g, "");
            return reject(new errors_1.ValidationError(msgString));
        }
    });
};
exports.validateJOI = validateJOI;
const concat = (x, y) => x.concat(y);
const flatMap = (xs, f) => xs.map(f).reduce(concat, []);
exports.flatMap = flatMap;
const flatMapAsync = async (xs, f) => (await Promise.all(xs.map(f))).reduce(concat, []);
exports.flatMapAsync = flatMapAsync;
const dive = (currentKey, into, target) => {
    for (let i in into) {
        if (into.hasOwnProperty(i)) {
            let newKey = i;
            let newVal = into[i];
            if (currentKey.length > 0) {
                newKey = `${currentKey}__${i}`;
            }
            if (Object(newVal) === newVal && !(newVal instanceof Date)) {
                dive(newKey, newVal, target);
            }
            else {
                target[newKey] = newVal;
            }
        }
    }
};
const flatten = (arr) => {
    let newObj = {};
    dive("", arr, newObj);
    return newObj;
};
exports.flatten = flatten;
const getSuccessBody = (returnVal) => {
    if (returnVal === undefined) {
        return { data: "ok" };
    }
    else if (returnVal.hasOwnProperty("code_response")) {
        // the res has the shape of an API response. We don't wrap it in the structure
        return returnVal;
    }
    else {
        return {
            code_response: errors_1.BUSINESS_ERROR.SUCCESS,
            data: returnVal,
        };
    }
};
exports.getSuccessBody = getSuccessBody;
const getErrorBody = (e) => {
    let secondStatus;
    let body;
    if (e.isBusinessError) {
        secondStatus = e.errorStatus;
        body = {
            code_response: secondStatus,
            error_message: e.message,
        };
        if (e.value)
            body.data = e.value;
        return body;
    }
    else {
        return { error: { message: e.message, name: e.name } };
    }
};
exports.getErrorBody = getErrorBody;
const getErrorStatus = (e, ctx) => {
    let status;
    if (e.status) {
        status = e.status;
    }
    else {
        status = 500;
    }
    if (e.isBusinessError) {
        return ctx.status;
    }
    else {
        return status;
    }
};
exports.getErrorStatus = getErrorStatus;
const encrypt = (value) => cryptr.encrypt(value);
exports.encrypt = encrypt;
const decrypt = (value) => cryptr.decrypt(value);
exports.decrypt = decrypt;
const isMainWorkflowTable = (tableName) => tableName.startsWith("w_") && tableName.split("_").length === 2;
exports.isMainWorkflowTable = isMainWorkflowTable;
const isSecondaryWorkflowTable = (tableName) => tableName.startsWith("w_") && tableName.split("_").length > 2;
exports.isSecondaryWorkflowTable = isSecondaryWorkflowTable;
const getDateBeforeMonths = (months) => {
    const d = new Date();
    d.setMonth(d.getMonth() - months);
    return d.toISOString();
};
exports.getDateBeforeMonths = getDateBeforeMonths;
const getVarEnv = (varEnvName) => {
    if (!process.env[varEnvName]) {
        throw new Error(`the environment variable ${varEnvName} is required.`);
    }
    return process.env[varEnvName];
};
exports.getVarEnv = getVarEnv;
const getBackendVersion = () => {
    var _a;
    if (process.env.NODE_ENV === "staging" ||
        process.env.NODE_ENV === "develop") {
        return process.env.NODE_ENV;
    }
    return (_a = process.env.BACKEND_VERSION) !== null && _a !== void 0 ? _a : "no_version";
};
exports.getBackendVersion = getBackendVersion;
const toUpperSnake = (text) => {
    return text
        .replace(/([A-Z])/g, " $1")
        .split(" ")
        .join("_")
        .toUpperCase();
};
exports.toUpperSnake = toUpperSnake;
const formatString = (pattern, element) => {
    if (!pattern && !element.label)
        return "/!\\ No Name";
    if (!pattern)
        return element.label;
    let result = "";
    const splittedPattern = pattern.split("$");
    for (let i = 0; i < splittedPattern.length; i++) {
        if (i % 2 === 1) {
            // even idx: we replace the string per the value of the attribute
            // if there is "." char, we split
            const attrs = splittedPattern[i].split(".");
            switch (attrs.length) {
                case 1:
                    result += element[splittedPattern[i]];
                    break;
                case 2:
                    result += element[attrs[0]][attrs[1]];
                    break;
                case 3:
                    result += element[attrs[0]][attrs[1]][attrs[2]];
                    break;
                default: /** nothing */
            }
        }
        else {
            // odd idx: we display the string as it is
            result += splittedPattern[i];
        }
    }
    if (result.length === 0) {
        return "/!\\ No Name";
    }
    return result;
};
exports.formatString = formatString;
__exportStar(require("./errors"), exports);
